import styled from 'styled-components';

// Common Page Container
export const PageContainer = styled.div`
  min-height: 100vh;
  background: #0B1122;
  padding: 2.5rem;
  color: white;
`;

// Common Back Button
export const BackButton = styled.button`
  font-size: 0.875rem;
  color: #5ce9ff;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-bottom: 1.5rem;
  transition: color 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  &:hover {
    color: #00f7d2;
  }
`;

// Common Header
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;

// Common Title
export const Title = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  color: white;
  margin: 0;
`;

// Section Title
export const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: white;
  margin: 2rem 0 1.5rem 0;
  
  &:first-of-type {
    margin-top: 0;
  }
`;

// Auction Title
export const AuctionTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: white;
`;

// Auction Meta
export const AuctionMeta = styled.p`
  font-size: 0.875rem;
  color: #9ca3af;
  margin: 0 0 1.5rem 0;
`;

// Common Button
export const PrimaryButton = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 0.75rem;
  background: ${props => props.disabled 
    ? 'rgba(255, 255, 255, 0.1)' 
    : 'linear-gradient(to right, #00f7d2, #5ce9ff)'};
  color: ${props => props.disabled ? '#9ca3af' : 'black'};
  border: none;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 1rem;
  transition: opacity 0.2s;
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
  
  &:disabled {
    opacity: 0.6;
  }
`;

// Loading Overlay
export const LoadingOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

// Empty State
export const EmptyState = styled.div`
  padding: 3rem 2rem;
  text-align: center;
  color: #9ca3af;
  
  h3 {
    color: white;
    margin-bottom: 0.5rem;
  }
  
  p {
    margin: 0;
  }
`;

// Grid Layout
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.5rem;
`;

